export default "__VITE_ASSET__KOXu5Dbb__"